module.exports = __webpack_public_path__ + "img/ktb.7d8e618.png";